import { tenant, forbidden, auth, common, menu, citySearch, validation, schedule, hr } from "./common";
import { ra } from "./ra";
import {
  user,
  group,
  role,
  company,
  jobApplication,
  jobApplicationSource,
  jobApplicationClosureReason,
  jobApplicationStatus,
  jobApplicationCalendar,
  jobApplicationDashboard,
  coursesManagement,
  myCourses,
  businessIntelligenceMarketAnalysis,
  businessIntelligenceSales,
  businessIntelligenceGeographicAnalysis,
  businessIntelligencePipelineAnalysis,
  businessIntelligenceIrt,
  conversation,
  conversations,
  tickets,
  ticket,
  contact,
  contactIdentity,
  channel,
  channelConnection,
  message,
  chat,
  email,
  ticketQueue,
  ticketQuickReply,
  internalChat,
  raFormLayout,
  tag,
  ticketTag,
  conversationTag,
  jobApplicationTag,
} from "./resources";

export const ptBrMessages: Record<string, any> = {
  tenant,
  forbidden,
  auth,
  common,
  ra,
  resources: {
    user,
    group,
    "job-application": jobApplication,
    "courses-management": coursesManagement,
    "my-courses": myCourses,
    company,
    "job-application-source": jobApplicationSource,
    "job-application-closure-reason": jobApplicationClosureReason,
    "job-application-status": jobApplicationStatus,
    role,
    "job-application-calendar": jobApplicationCalendar,
    "job-application-dashboard": jobApplicationDashboard,
    "business-intelligence/market-analysis": businessIntelligenceMarketAnalysis,
    "business-intelligence/sales": businessIntelligenceSales,
    "business-intelligence/geographic-analysis": businessIntelligenceGeographicAnalysis,
    "business-intelligence/pipeline-analysis": businessIntelligencePipelineAnalysis,
    "business-intelligence/irt": businessIntelligenceIrt,
    conversation,
    conversations,
    tickets,
    ticket,
    contact,
    channel,
    message,
    chat,
    email,
    "ticket-queue": ticketQueue,
    "ticket-quick-reply": ticketQuickReply,
    tag,
    "ticket-tag": ticketTag,
    "conversation-tag": conversationTag,
    "job-application-tag": jobApplicationTag,
    "channel-connection": channelConnection,
    "contact-identity": contactIdentity,
    "internal-chat": internalChat,
  },
  hr,
  menu,
  citySearch,
  validation,
  "ra-form-layout": raFormLayout,
  schedule,
};
